/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Participant } from './participant';
import {
    ParticipantFromJSON,
    ParticipantFromJSONTyped,
    ParticipantToJSON,
    ParticipantToJSONTyped,
} from './participant';

/**
 * 
 * @export
 * @interface WsParticipantCreated
 */
export interface WsParticipantCreated {
    /**
     * Type of the message
     * @type {string}
     * @memberof WsParticipantCreated
     */
    type: string;
    /**
     * The conversation ID
     * @type {string}
     * @memberof WsParticipantCreated
     */
    conversationId: string;
    /**
     * 
     * @type {Array<Participant>}
     * @memberof WsParticipantCreated
     */
    participants?: Array<Participant> | null;
}

/**
 * Check if a given object implements the WsParticipantCreated interface.
 */
export function instanceOfWsParticipantCreated(value: object): value is WsParticipantCreated {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    return true;
}

export function WsParticipantCreatedFromJSON(json: any): WsParticipantCreated {
    return WsParticipantCreatedFromJSONTyped(json, false);
}

export function WsParticipantCreatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsParticipantCreated {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'conversationId': json['conversation_id'],
        'participants': json['participants'] == null ? undefined : ((json['participants'] as Array<any>).map(ParticipantFromJSON)),
    };
}

export function WsParticipantCreatedToJSON(json: any): WsParticipantCreated {
    return WsParticipantCreatedToJSONTyped(json, false);
}

export function WsParticipantCreatedToJSONTyped(value?: WsParticipantCreated | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'conversation_id': value['conversationId'],
        'participants': value['participants'] == null ? undefined : ((value['participants'] as Array<any>).map(ParticipantToJSON)),
    };
}

